// Shared landing imagery + constants
export const loginTo = (dest) => `/login?redirect=${encodeURIComponent(dest)}`;

const u = (id, w = 1200) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=${w}`;

export const IMG = {
  hero: u("1569531955323-33c6b2dca44b", 1920),
  heroAlt: u("1512719994953-eabf50895df7", 1200),
  tourism: "https://images.pexels.com/photos/26653528/pexels-photo-26653528.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  live: "https://images.pexels.com/photos/31925496/pexels-photo-31925496.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  community: u("1552674605-db6ffd4facb5", 1000),
};

export const POPULAR_SPORTS = [
  { name: "Cricket", img: u("1593341646782-e0b495cff86d", 600) },
  { name: "Football", img: "https://images.pexels.com/photos/32285250/pexels-photo-32285250.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Badminton", img: u("1720515226352-b0b1dec6813b", 600) },
  { name: "Tennis", img: u("1545151414-8a948e1ea54f", 600) },
  { name: "Basketball", img: u("1559369064-c4d65141e408", 600) },
  { name: "Swimming", img: u("1530549387789-4c1017266635", 600) },
];

// Fallback image for a facility/sport when it has no image_url.
const SPORT_IMG = Object.fromEntries(POPULAR_SPORTS.map((s) => [s.name.toLowerCase(), s.img]));
export const sportImage = (sport) => SPORT_IMG[(sport || "").toLowerCase()] || IMG.heroAlt;

// Clearly-labelled sample listings shown until real verified facilities exist.
export const DEMO_FACILITIES = [
  { name: "Greenfield Turf Arena", sport: "Football · Cricket", city: "Bengaluru", price: 900, rating: 4.8, img: u("1556056504-5c7696c4c28d", 800) },
  { name: "Smash Badminton Club", sport: "Badminton", city: "Pune", price: 450, rating: 4.7, img: "https://images.pexels.com/photos/8007495/pexels-photo-8007495.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "AquaFit Swimming Centre", sport: "Swimming", city: "Mumbai", price: 300, rating: 4.6, img: "https://images.pexels.com/photos/9030294/pexels-photo-9030294.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Downtown Hoops Court", sport: "Basketball", city: "Hyderabad", price: 600, rating: 4.5, img: "https://images.pexels.com/photos/5407033/pexels-photo-5407033.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];
